import React, { Fragment, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { getRegion } from '../../../../../../utils/Region';
import { canPlay, getTimeShift } from 'containers/Player/utils/PlayRules';
import { isFutureEvent } from './../../utils';
//-----------------------------------------------------------------------------------------
import { AditionalInfo } from './../AditionalInfo';
import { LiveInfo } from '../LiveInfo';
import './style.scss';
import { useVisiblePlayButton } from './hooks/useVisiblePlayButton';
import { getContentInfoLive } from '../../../../utils/getDataFromLiveVodContent';
import { checkIfChannelIsBlocked } from 'containers/EPG/actions/channelBlocker/blocker.actions';
import {
  setKeywordSearch,
  setLiveMenuOptions,
} from 'containers/NewSearchPage/redux/actions/searchActions';
import { getCurrentEvent } from './utls/getCurrentEvent';
import { eventIsAllow } from 'containers/EPG/utils';
import qs from 'qs';
import { browserHistory } from 'react-router';
import { useGetRecord } from '../LiveInfo/hooks/useGetRecord';
import { setRecordingToPlay } from 'containers/Player/actions/recordings/recordings.actions';
import { getRecordedInfo } from './utls/getRecordedInfo';
import { getTranslation, jsonParseTraslation } from 'utils/getTranslation';
import { getChannelFromEpg } from 'containers/NewSearchPage/utils/getChannelFromEpg';
import buttonOptionClick from 'containers/Player/actions/optionButtons/optionButtons.actions';
import {
  clearVCardData,
  getContentByGroupId,
} from '../../../../../Vcard/actions/content/content.actions';
import { selectVCardContent } from '../../../../../Vcard/selectors/vcard.selector';
import { unLockVodContentbyGroudId } from '../../../../../Vcard/actions/content/unLockVodContent.actions';
import {
  EPG_SET_CURRENT_CHANNEL,
  SET_EVENT_FROM_EPG,
} from 'containers/Player/actions/liveMenu/constants';
import { useGetEventFromEpg } from '../../hooks/useGetEventFromEpg';
import Utils from 'utils/Utils';
import ClaroUrlBuilder from 'utils/ClaroUrlBuilder';
import { useHandlePlayContent } from '../../hooks/useHandlePlayContent';
import { useNavigate } from 'react-router-dom';
import { FETCH_CONTENT_DATA_SUCCESS } from 'containers/Player/actions/content/constants';
import { FETCH_PBI_SUCCESS } from 'containers/Player/actions/pbi/constants';

export const DetailsCard = ({ contentInfo, value }) => {
  const dispatch = useDispatch();
  const [vodGroupId, setVodGroupId] = useState(null);
  const infoGeneral = getContentInfoLive(contentInfo);
  const { content_playing_option_button_play } = useSelector(
    state => state.asset,
  );
  const texts = useSelector(state => state.metadata.translations);
  const parseTranslation = jsonParseTraslation(texts);
  const abbreviationsSeasonLabel = getTranslation(
    'content_data_abbreviationSeason_label',
    parseTranslation,
  );
  const recordedText = getTranslation(
    'playing_playerControls_toolbar_button_recorded',
    parseTranslation,
  );
  const infinite = useSelector(state => state.linealChannel?.data);
  const info = useSelector(selectVCardContent);
  const navigate = useNavigate();

  const adapterRes = contentInfo?.content_type || contentInfo?.type;

  const { isVisiblePlayButton } = useVisiblePlayButton(
    infoGeneral.id,
    adapterRes,
    infoGeneral.begintime,
  );
  const { recordingStatus, recordingStatusIcon, eventRecorded } = useGetRecord(
    contentInfo,
  );

  const currentEvent = getCurrentEvent(adapterRes, infoGeneral.id);
  const { eventFromEpg, channelFromEpg } = useGetEventFromEpg({ contentInfo });
  const {
    handleFutureEvent,
    handlePlayOnMobile,
    handleNowEvent,
    handlePastEvent,
  } = useHandlePlayContent();

  const handlePlayClick = async e => {
    e.stopPropagation();
    handlePlayOnMobile(infoGeneral.id);

    const evenTime = {
      date_begin: infoGeneral.begintime,
      date_end: infoGeneral.endtime,
    };
    if (adapterRes === 'E' || adapterRes === 'L') {
      const eventType = eventIsAllow(evenTime);
      if (eventType !== 'before' && eventType !== 'after') {
        handleNowEvent(infoGeneral.id);
      }
      if (eventType === 'after') {
        handleFutureEvent(infoGeneral?.id, eventFromEpg, contentInfo);
      }
      if (eventType === 'before') {
        if (recordingStatus === 'ingested') {
          const recordedInfoToPlay = getRecordedInfo(eventRecorded);
          dispatch(setRecordingToPlay(recordedInfoToPlay, () => {}));
          dispatch(
            checkIfChannelIsBlocked({
              group_id: infoGeneral.id,
              onSuccess: () =>
                navigate(`/${getRegion()}/watch/${infoGeneral.id}`),
            }),
          );

          return dispatch(setKeywordSearch(value));
        }
        handlePastEvent(infoGeneral.id, eventFromEpg, channelFromEpg);

        //SETEAR LA KEYWORD
        dispatch(setKeywordSearch(value));
        return;
      }
    }

    //Reproducir un contenido VOD
    dispatch(getContentByGroupId(infoGeneral.id));
    setVodGroupId({ groupId: infoGeneral.id });
    //SETEAR LA KEYWORD
    dispatch(setKeywordSearch(value));
  };

  //Esta funcion devuelve la info que se renderiza debajo del titulo
  const renderContentInfo = () => {
    switch (adapterRes) {
      case 'P':
        return (
          <Fragment>
            <h2 className="details-card__title vod">{contentInfo?.title}</h2>
            <span className="details-card__info">{contentInfo?.year}</span>
          </Fragment>
        );
      case 'S':
        return (
          <Fragment>
            <h2 className="details-card__title vod">{contentInfo?.title}</h2>
            <span className="details-card__info">{`${
              contentInfo?.season_number
            } ${abbreviationsSeasonLabel} | ${contentInfo?.year}`}</span>
          </Fragment>
        );
      case 'E':
        if (recordingStatus === 'ingested') {
          return (
            <Fragment>
              <h2 className="details-card__title">{contentInfo?.name}</h2>
              <span className="details-card__info">{`${
                contentInfo?.channel_number
              } | ${contentInfo?.channel_name}`}</span>

              <div className="details-card-ingested-recorded">
                <span>
                  {`${contentInfo?.duration?.split(':')[0]} hr | ${
                    contentInfo?.duration?.split(':')[1]
                  } min`}
                </span>
                <div className="details-card-container-img_recorded">
                  <img
                    className="detalis-card__info_img_recorded"
                    src={recordingStatusIcon}
                    alt="record"
                  />
                  {recordedText}
                </div>
              </div>
            </Fragment>
          );
        }
        return (
          <Fragment>
            <h2 className="details-card__title">{contentInfo?.name}</h2>
            <span className="details-card__info live">{`${
              contentInfo?.channel_number
            } | ${contentInfo?.channel_name}`}</span>
            <LiveInfo contentInfo={contentInfo} />
          </Fragment>
        );
      case 'L':
        return (
          <Fragment>
            <h2 className="details-card__title">
              {currentEvent?.name || contentInfo?.actual_event?.name || ''}
            </h2>
            <span className="details-card__info live">{`${
              contentInfo?.channel_number
            } | ${contentInfo?.title || ''}`}</span>
            <LiveInfo contentInfo={contentInfo} />
          </Fragment>
        );
      default:
        break;
    }
  };

  useEffect(
    () => {
      if (
        vodGroupId === null ||
        !info?.rate?.id ||
        info?.group_id !== vodGroupId?.groupId ||
        contentInfo?.content_type === 'L' ||
        contentInfo?.content_type === 'E' ||
        contentInfo?.type === 'E' ||
        contentInfo?.type === 'L'
      )
        return;
      // verificamos si estamos en mobile
      if (Utils.MobileCheck()) {
        const goTo = ClaroUrlBuilder.mobileGoToApp(
          getRegion(),
          infoGeneral.id,
          false,
        );
        return document.location.assign(goTo);
      }

      dispatch(
        checkIfChannelIsBlocked({
          group_id: infoGeneral.id,
          rating: info?.rate?.id,
          onSuccess: () =>
            navigate(`/${getRegion()}/watch/${infoGeneral.id}?search=1`),
        }),
      );
      localStorage.setItem('rateVodContent', JSON.stringify(info?.rate));
      dispatch(unLockVodContentbyGroudId(infoGeneral.id));
      dispatch(clearVCardData());
    },
    [info?.group_id, info?.rate?.id, vodGroupId],
  );

  return (
    <div
      className={`${
        contentInfo?.content_type !== 'E' ? 'details-card' : 'details-card live'
      }`}
    >
      <div className="details-card__main">
        {renderContentInfo()}
        {isVisiblePlayButton && (
          <button
            className="details-card__play-button"
            type="button"
            style={{
              backgroundImage: `url(${content_playing_option_button_play})`,
            }}
            onClick={handlePlayClick}
          />
        )}
      </div>
      <AditionalInfo contentInfo={contentInfo} />
    </div>
  );
};

DetailsCard.propTypes = {
  contentInfo: PropTypes.object.isRequired,
};
